import React from 'react';
import { Transition } from 'react-transition-group';
const duration = 300;

const out = { opacity: 0, marginLeft: -20 };
const transitionStyles = {
  exited: out,
  entering: { ...out, position: 'absolute' },
  exiting: out,
  entered: { opacity: 1, marginLeft: 0 }
};

type Props = {
  className: String,
  in: Boolean,
  children: React.CElement
};

const DEFAULT_TIMEOUT = {
  enter: 30,
  exit: duration
};

export default function SlideLeft({
  in: inProp,
  onExited,
  children,
  style = {},
  timeout,
  ...rest
}: Props) {
  if (!timeout) timeout = DEFAULT_TIMEOUT;

  return (
    <Transition in={inProp} mountOnEnter unmountOnExit enter appear exit timeout={timeout}>
      {state => (
        <div
          {...rest}
          style={{
            ...style,
            transition: `opacity ${duration}ms cubic-bezier(0.4, 0.0, 0.2, 1), margin-left ${duration}ms cubic-bezier(0.4, 0.0, 0.2, 1)`,
            ...transitionStyles[state]
          }}>
          {children}
        </div>
      )}
    </Transition>
  );
}
